import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchSpecialtyCoverage,
  updateSpecialtyCoverage,
  type UpdateSpecialtyCoveragePayload,
} from '../api/specialtyCoverageApi';

export const specialtyCoverageKeys = {
  all: ['provider', 'specialty-coverage'] as const,
};

export function useSpecialtyCoverage() {
  return useQuery({
    queryKey: specialtyCoverageKeys.all,
    queryFn: fetchSpecialtyCoverage,
  });
}

export function useUpdateSpecialtyCoverage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateSpecialtyCoveragePayload) =>
      updateSpecialtyCoverage(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(specialtyCoverageKeys.all, data);
    },
  });
}
